import _ from 'underscore';

export const getReportCalculationData = (test, ticket, showCompanyPopulationDistribution) => {
  let MINIMUM_DISTRIBUTION_COUNT = 15;
  let peopleGotEqualOrLessMarks = 0;
  let distributionCount = 0;
  let distribution = showCompanyPopulationDistribution ? test.companyTestDistribution : test.distribution;
  let reportHasDistribution;

  _.each(distribution, function (distributionEntry) {
    if (_.isObject(distributionEntry)) {
      distributionCount += distributionEntry.count;
      if (distributionEntry.maxValue <= ticket.rating) {
        peopleGotEqualOrLessMarks += distributionEntry.count;
      }
    } else {
      distributionCount += distributionEntry;
    }
  });

  reportHasDistribution = showCompanyPopulationDistribution
    ? distributionCount >= 1
    : distributionCount >= MINIMUM_DISTRIBUTION_COUNT;

  let data = {
    hasDistribution: reportHasDistribution,
    numberOfCandidates: distributionCount,
    peopleGotEqualOrLessMarks: peopleGotEqualOrLessMarks,
    distributionCount: distributionCount,
  };

  return data;
};

export const calculatePercentage = (test, ticket, showCompanyPopulationDistribution, forceScoreOverPercentile) => {
  let percentage;
  if (test.adaptiveTest && ticket.rating) {
    if (_.has(ticket, 'distributionPercentage') && !showCompanyPopulationDistribution) {
      percentage = ticket.distributionPercentage;
    } else {
      getReportCalculationData(test, ticket, showCompanyPopulationDistribution, function (data) {
        percentage = (data.peopleGotEqualOrLessMarks * 100) / data.distributionCount;
      });
    }
  } else {
    if (_.has(ticket, 'distributionPercentage') && !showCompanyPopulationDistribution && !forceScoreOverPercentile) {
      percentage = ticket.distributionPercentage;
    } else {
      percentage = (ticket.result * 100) / test.scale;
    }
  }
  if (_.isNaN(percentage)) {
    percentage = 0;
  }
  return percentage;
};
